'use client'
import SubnavDefaultSection from './SubnavDefaultSection'
import SubnavPanelSection from './SubnavPanelSection'

export const Subnav = ({ setHoverSubnav, setHoverNavigation, data }) => {
  const Component = data.variant === 'list' ? SubnavDefaultSection : SubnavPanelSection

  return (
    <div
      data-testid="mega-menu-subnav-section"
      className="absolute w-screen flex flex-row justify-center items-center z-9999"
    >
      <div
        className="min-w-[400px] shadow-[0px_27px_74px_0px_rgba(29,37,47,0.11)] bg-white rounded-md"
        onMouseEnter={() => setHoverSubnav(true)}
        onMouseLeave={() => {
          setHoverSubnav(false)
          setHoverNavigation(false)
        }}
      >
        <Component data={data} isMobile={false} setHoverSubnav={setHoverSubnav} />
      </div>
    </div>
  )
}

export default Subnav
